// services/components/strategies/common/CommandPalette/Modal.tsx
'use client'

import React from 'react'
import dynamic from 'next/dynamic'
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react'
import { UUID } from '@/utils/idGenerator'

// Lazy load the SearchBar island to cut idle JS
const SearchBarIsland = dynamic(
  () => import('@/services/components/strategies/search-bar/SearchBar.state'),
  {
    ssr: false,
    loading: () => (
      <div className="w-full">
        <div className="h-[48px] w-full rounded-full border border-grey-300 bg-white" />
      </div>
    ),
  },
)

export interface ModalProps {
  id?: string
  isOpen: boolean
  onClose: () => void
  placeholder: string
  autoFocus: boolean
}

const Modal: React.FC<ModalProps> = ({
  id = UUID(),
  isOpen,
  onClose,
  placeholder,
  autoFocus,
}) => {
  return (
    <Dialog className="relative z-[10000]" open={isOpen} onClose={onClose}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-white/30 backdrop-blur-sm transition-opacity
                   data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200
                   data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-[10000] w-screen overflow-y-auto p-4 sm:p-6 md:p-20">
        <DialogPanel transition>
          {isOpen && (
            <SearchBarIsland
              id={id}
              placeholder={placeholder}
              autoFocus={autoFocus}
            />
          )}
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default Modal
